<template>
  <div
    class="
      col-span-full
      grid grid-cols-1
      gap-x-4 gap-y-8
      md:grid-cols-2
      lg:grid-cols-3
      pb-4
      mt-8
    "
  >
    <AnalyticsReporting />
    <Content
      v-show="todayReport"
      class="col-span-full w-full"
      title="FLEET_STAT"
      childClass="h-full flex flex-col"
      :showBreadcrumb="false"
      :showAdd="false"
    >
      <div class="grid xl:grid-cols-3 gap-y-12 gap-6 mt-4">
        <div
          class="
            flex flex-col
            items-center
            gap-2
            flex-grow
            justify-center
            lg:justify-start
            space-y-3
          "
          v-if="todayReport && todayReport.max_speed_company_vehicle"
        >
          <span class="font-bold">
            {{ $t('driver_max_speed_in_last_24_hour') }}
          </span>
          <div
            class="text-gray-500 text-sm"
            v-if="todayReport && !todayReport.max_speed_company_vehicle.driver"
          >
            بدون راننده
          </div>
          <div v-else>
            <span class="text-carpo font-semibold text-lg">
              {{
                todayReport.max_speed_company_vehicle.driver.first_name +
                ' ' +
                todayReport.max_speed_company_vehicle.driver.last_name
              }}
            </span>
          </div>
        </div>

        <div
          class="
            flex flex-col
            items-center
            gap-2
            flex-grow
            justify-center
            lg:justify-start
          "
          v-if="
            !!todayReport &&
            !!todayReport.max_speed_company_vehicle &&
            !!todayReport.max_speed_company_vehicle.vehicle
          "
        >
          <span class="font-bold">
            {{ $t('VEHICLE_TITLE') }}
          </span>
          <div class="text-gray-500 text-sm text-center">
            <LicensePlate
              type="dashboard"
              :vehicle="todayReport.max_speed_company_vehicle.vehicle"
              :color="todayReport.max_speed_company_vehicle.color"
              :license_plate="
                todayReport.max_speed_company_vehicle.license_plate
              "
              :chars="alphaList"
            ></LicensePlate>
          </div>
        </div>

        <Service
          :title="$t('MAX_SPEED')"
          type="h"
          :summary="todayReport && todayReport.max_speed"
        />

        <Service
          :title="$t('max_speed_datetime')"
          :showType="false"
          size="text-lg"
          :summary="
            todayReport &&
            todayReport.max_speed_datetime &&
            new Date(todayReport.max_speed_datetime).toLocaleTimeString('fa-IR')
          "
        />
        <Service
          :title="$t('AVG_SPEED')"
          :summary="todayReport && todayReport.mean_speed"
          type="h"
        />
        <!-- <Service
          :title="$t('ODOMETER')"
          :summary="
            fleetStat &&
            Math.ceil(
              fleetStat.fleet_total_traveled_distance_in_last_24_hour / 1000
            )
          "
        />
         -->

        <!-- <Service
          :title="$t('driver_max_traveled_distance_in_last_24_hour')"
          :showType="false"
          size="text-lg"
          :summary="
            todayReport &&
            todayReport.driver_max_traveled_distance_in_last_24_hour
          "
        />
        
        <Service
          :title="$t('fleet_max_traveled_distance_in_last_24_hour')"
          
          size="text-lg"
          :summary="
            todayReport &&
            Math.ceil(todayReport.fleet_max_traveled_distance_in_last_24_hour / 1000)
          "
        /> -->
      </div>
    </Content>

    <div class="grid col-span-full gap-4 lg:grid-cols-2 xl:grid-cols-3">
      <Content
        v-show="realtimeChart.length > 0"
        title="realtime_status"
        :showBreadcrumb="false"
        :showAdd="false"
        childClass="h-full"
      >
        <Summary :summary="realtimeChart" />
      </Content>

      <Content
        v-show="driverStats.length > 0"
        title="DRIVER_SUMMARY"
        :showBreadcrumb="false"
        :showAdd="false"
        childClass="h-full"
      >
        <Summary :summary="driverStats" />
      </Content>

      <Content
        v-show="ownershipStats.length > 0"
        title="OWNERSHIP_SUMMARY"
        :showBreadcrumb="false"
        :showAdd="false"
        childClass="h-full"
      >
        <Summary :summary="ownershipStats" />
      </Content>

      <Content
        v-show="vehicleStats.length > 0"
        title="VEHCILE_SUMMARY"
        :showBreadcrumb="false"
        :showAdd="false"
        childClass="h-full"
      >
        <Summary :summary="vehicleStats" />
      </Content>
    </div>

    <!-- <TodayStats /> -->
  </div>
</template>

<script>
import Summary from '@/pages/home/summary'
import RealTime from '@/pages/home/realtime'
import ChooseCar from '@/pages/home/ChooseCar'
import Service from '@/pages/home/service'
import LicensePlate from '@/components/cars/LicensePlate'
import { licenseChars } from '@/api/global'
import AnalyticsReporting from '@/pages/reporting/index.vue'

import {
  fleetTodays,
  driversStats,
  vehiclesOwnershipStats,
  vehiclesStats,
} from '@/api/dashboard'

export default {
  data() {
    return {
      isRealVisible: true,
      drivers_stat: {
        status_stat: [],
      },
      alphaList: [
        {
          char: '',
          code: '',
        },
      ],
      driverLoading: true,
      vehicleLoading: true,
      vehicle_stat: {
        driver_status_stats: [],
        vehicle_ownership_stats: [],
        vehicle_status_stats: [],
      },
      driverStats: [],
      ownershipStats: [],
      realtimeChart: [],
      vehicleStats: [],
      imei: [],

      res: null,
      fleetStat: null,
      todayReport: null,
      showRealtime: false,
    }
  },
  components: {
    Summary,
    RealTime,
    ChooseCar,
    Service,
    LicensePlate,
    AnalyticsReporting,
    // TodayStats
  },
  methods: {
    async liveLocation() {
      const res = await this.$store.dispatch('liveTracking', {
        selectedVehicle: '',
        selectedTags: '',
        selectedStatus: '',
      })
      if (res) {
        this.showRealtime = true
        this.realtimeChart = [
          {
            id: 1,
            color: {
              id: 1,
              en_title: 'green',
              fa_title: 'سبز',
              code: '#67C23A',
            },
            count: res.filter(
              (item) => item.properties.traffic_status !== 'offline'
            ).length,
            en_title: this.$t('updated_vechiles'),
            fa_title: this.$t('updated_vechiles'),
          },
          {
            id: 2,
            color: {
              id: 2,
              en_title: 'gray',
              fa_title: 'طوسی',
              code: '#f59e0b',
            },
            count: res.filter(
              (item) => item.properties.traffic_status === 'offline'
            ).length,
            en_title: this.$t('updated_not_vechiles'),
            fa_title: this.$t('updated_not_vechiles'),
          },
        ]
      }
    },
  },
  mounted() {
    licenseChars.api().then((res) => {
      this.alphaList = res
    })

    fleetTodays.api().then((res) => {
      if (res) {
        this.todayReport = res
      }
    })

    driversStats.api().then((res) => {
      if (res) {
        this.driverStats = res
      }
    })

    vehiclesOwnershipStats.api().then((res) => {
      if (res) {
        this.ownershipStats = res
      }
    })
    vehiclesStats.api().then((res) => {
      if (res) {
        this.vehicleStats = res
      }
    })
    this.liveLocation()
  },
}
</script>
